module.exports = __webpack_public_path__ + "68aefe100f4b4b1181cb0df7e7cf2aa2.pdf";